import React from "react";
import { Routes, Route } from "react-router-dom";

import Metabase from "./Metabase";

const index = () => {
	return (
		<Routes>
			<Route index element={<Metabase />} />
		</Routes>
	);
};

export default index;
